import { Component, inject } from '@angular/core';
import { MandantConfigService } from '@strategies/mandant-config.service';
import { BaseDynamicContainer } from '@strategies/_containers/base-dynamic.container';
import { SpinnerOverlayDefaultComponent } from '@strategies/_default/spinner-overlay';

@Component({
  selector: 'spinner-overlay',
  template: '<ng-template #dynamic></ng-template>',
  styleUrls: [],
  standalone: false,
})
export class SpinnerOverlayContainerComponent extends BaseDynamicContainer {
  mandantConfigService: MandantConfigService;

  constructor() {
    const mandantConfigService = inject(MandantConfigService);

    super(mandantConfigService);

    this.mandantConfigService = mandantConfigService;
  }

  protected override getComponent() {
    return this.viewContainerRef.createComponent(SpinnerOverlayDefaultComponent);
  }
}
